import { Panel } from '../ui/Panel';
import { Field } from '../ui/Field';
import { inputCls } from '../ui/styles';
import { ContentEditor, type Json } from '../ui/ContentEditor';
import { SettingNumber } from './SettingNumber';
import { useSettings } from './useSettings';
import { GiftStockLinks } from './GiftStockLinks';
import { euro } from '../../core/format/currency';
import type { GiftTier } from '../../core/types/site';
type Props = {
  onOpenShipping: () => void;
};

/**
 * Instellingen › Cadeaus & codes › Cadeaus bij bestelling. De eerste trede is altijd gratis
 * verzending: die staat hier vast en volgt het bedrag uit Webshop & verzending (één bron).
 */
export function GiftSettings({
  onOpenShipping
}: Props) {
  const {
    site,
    setSite,
    policy,
    setPolicy
  } = useSettings();
  const sorted = [...site.giftTiers].sort((a, b) => a.threshold - b.threshold);
  const [first, ...rest] = sorted;
  const setRest = (next: Json) => setSite(s => ({
    ...s,
    giftTiers: [...(first ? [first] : []), ...(next as unknown as GiftTier[])]
  }));
  return <>
      <Panel title="Cadeaus bij bestelling" description="Wat een klant cadeau krijgt vanaf een bepaald bedrag — nooit korting." data-id="element-4013" data-mp="2fctcgu887lkn">
        <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2 border-b border-line pb-4 text-[14px]" data-id="element-4014" data-mp="2kal2tjt82zmq">
          <p className="text-ink" data-id="element-4015" data-mp="2bbzjvnju9ilf">
            Vanaf {euro(policy.freeShippingFrom)}: <span className="text-muted" data-id="element-4016" data-mp="2be3q4c57mtov">gratis verzending</span>
          </p>
          <button type="button" onClick={onOpenShipping} className="text-[13px] text-ink underline underline-offset-2 hover:text-clay" data-id="element-4017" data-mp="2z23re605e2hp">
            Bedrag aanpassen bij Verzending
          </button>
        </div>
        <ContentEditor value={rest as unknown as Json} onChange={setRest} fieldKey="giftTiers" data-id="element-4018" data-mp="2pbiklvablrnp" />
        <GiftStockLinks tiers={rest} onChange={(ruleId, patch) => setSite(s => ({
        ...s,
        giftTiers: s.giftTiers.map(t => t.ruleId === ruleId ? {
          ...t,
          ...patch
        } : t)
      }))} data-id="element-4019" data-mp="2u90vhr7wegyc" />
      </Panel>
      <Panel title="Cadeaus en cadeaubonnen" data-id="element-4020" data-mp="3mszfot5eafk7">
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-4021" data-mp="gpk2bv1k248">
          <SettingNumber label="Videoconsult in de hoogste trede (minuten)" value={policy.giftConsultMinutes} onChange={v => setPolicy('giftConsultMinutes', v)} min={5} max={120} data-id="element-4022" data-mp="fehgfdc10ep" />
          <SettingNumber label="Cadeaubon geldig (maanden)" hint="Staat op de bon en in de voorwaarden." value={policy.giftCardValidMonths} onChange={v => setPolicy('giftCardValidMonths', v)} min={1} max={120} data-id="element-4023" data-mp="3hp2s7778yhwm" />
          <Field label="Nieuwe cadeaubon geldt voor" hint="Geldt voor bonnen die je vanaf nu maakt of verkoopt. Bestaande bonnen houden hun keuze." className="sm:col-span-2" data-id="element-4024" data-mp="33ziska8yq0rj">
            <select value={policy.giftCardValidFor} onChange={e => setPolicy('giftCardValidFor', e.target.value === 'treatments' ? 'treatments' : 'all')} className={`${inputCls} sm:max-w-sm`} data-id="element-4025" data-mp="2tzi7ojvg3cl8">
              <option value="all" data-id="element-4026" data-mp="19hptqdelbb3l">Behandelingen én producten in de webshop</option>
              <option value="treatments" data-id="element-4027" data-mp="1ehc5eiersjaa">Alleen behandelingen in de salon</option>
            </select>
          </Field>
        </div>
      </Panel>
    </>;
}